import { FC } from 'react'

import styles from './offerCard.module.scss'

interface OfferCardProps {
  amount: number // minor units (cents)
  currency: string
  interval: string
  isProcessing?: boolean
  onSubscribe: () => void
  productName: string
}

const OfferCard: FC<OfferCardProps> = ({
  amount,
  currency,
  interval,
  isProcessing = false,
  onSubscribe,
  productName,
}) => {
  const price = new Intl.NumberFormat('en-US', {
    currency: currency.toUpperCase(),
    style: 'currency',
  }).format(amount / 100)

  return (
    <div className={styles.offerCard}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>{productName}</h3>
          <span className={styles.badge}>Offered to you</span>
        </div>
        <p className={styles.description}>
          A plan prepared for your account. Subscribe to activate it.
        </p>
      </div>

      <div className={styles.priceRow}>
        <span className={styles.amount}>{price}</span>
        <span className={styles.period}>/ {interval}</span>
      </div>

      <div className={styles.divider} />

      <button
        className={styles.subscribeButton}
        disabled={isProcessing}
        onClick={onSubscribe}
        type="button"
      >
        {isProcessing ? 'Loading…' : 'Subscribe'}
      </button>
    </div>
  )
}

export default OfferCard
